import { render } from "./AlarmPointTable.vue?vue&type=template&id=b13fbc80&scoped=true"
import script from "./AlarmPointTable.vue?vue&type=script&lang=js"
export * from "./AlarmPointTable.vue?vue&type=script&lang=js"

import "./AlarmPointTable.vue?vue&type=style&index=0&id=b13fbc80&lang=scss&scoped=true"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13fbc80"]])

export default __exports__